import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { closeManageSubscription } from '../../../../action/manage-subscription';
import './index.scss'
import BackArrow from '../../../../../asset/Arrow-Left_Med.svg'
import TableData from './table/table';
import SearchAssigne from './searchAssigne';
import superagent from 'superagent'
import { fetchAssignedSubscription } from '../../../../action/subscription-api';
import { openAssignSubscription, closeAssignSubscription } from '../../../../action/sub-showAssigne-action'
import { showHideSubscriptionModal } from '../../../../utils/subscriptionUtils';
import { getPurchasedSubscription } from '../../../../lib/util';

const LandingPage = (props) => {
  // Resolve the paid plan by plan id rather than array position (the list is not guaranteed to be
  // ordered free-then-paid). See getPurchasedSubscription.
  const purchasedPlan = getPurchasedSubscription(props?.user?.userSubscription)
  const [subId, setSubId] = useState(purchasedPlan?.id)
  const [searchString, setsearchString] = useState('')

  let close = () => {
    if (props.assignSubscriptionTab) {
      props.closeAssignSubscription()
      subId &&
        props.fetchAssignedSubscription(subId)
          .then((res) => { })
          .catch((err) => { })
    }
    else {
      props.closeManageSubscription()
      props.closeAssignSubscription()
    }
  }

  let onchangeSearch = (e) => {
    setsearchString(e.target.value)
  }

  return (
    <div className={`subscription-page-container ${props.assignSubscriptionTab ? 'set-width-assigne' : 'set-width'}`} >

      <img className='sub-close-icon' src={BackArrow} onClick={close}></img>

      {!props.assignSubscriptionTab ?
        <>
          <div className='sub-header-container'>
            <p className='manage-sub-main-header'>Manage Subscrition</p>

            <div className='sub-counts'>
              <p>{props.subscriptionAssigned?.quantity} Seats: {props.subscriptionAssigned?.assigned + 1} in use, {props.subscriptionAssigned?.unassigned} open, {0} pending</p>

              <input className='find-user-input' placeholder='Find user' value={searchString} onChange={(e) => onchangeSearch(e)} style={{}}></input>
            </div>

          </div>
          <TableData
            subId={subId}
            subscriptionName={getPurchasedSubscription(props?.userSubscription)?.subscriptionPlanId == 44 ? 'Pro Ultimate' : getPurchasedSubscription(props?.userSubscription)?.subscriptionPlanId == 36 ? 'Prod Advantage' : 'Pro'}
            // assignedSubscription={props.assignedSubscription}
            loader={props.loader}
            searchString={searchString}
          ></TableData>
        </>
        :
        <SearchAssigne
          subscriptionId={subId}
        ></SearchAssigne>
      }

    </div>
  )
}


const mapStateToProps = state => ({
  auth: state.auth,
  manageSubscription: state.manageSubscription,
  assignSubscriptionTab: state.assignSubscriptionTab,
  userSubscription: state.userSubscription,
  subscriptionAssigned: state.subscriptionAssigned,
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  closeManageSubscription: () => dispatch(closeManageSubscription()),
  closeAssignSubscription: () => dispatch(closeAssignSubscription()),
  fetchAssignedSubscription: (payload) => dispatch(fetchAssignedSubscription(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage)
